module.exports = __webpack_public_path__ + "img/1F1F9-1F1E9.a0e3dace.svg";